<template>
  <div class="rider-dispatch">
    <el-row :gutter="16" class="dispatch-layout">
      <el-col :span="16">
        <div class="map-container">
          <div id="baidu-map" class="map-inner"></div>
        </div>
      </el-col>
      <el-col :span="8">
        <el-card class="panel">
          <div slot="header" class="clearfix">
            <span>骑手列表与订单</span>
          </div>
          <el-table
            :data="riderStatusList"
            height="260"
            size="mini"
            @row-click="handleRiderClick"
          >
            <el-table-column prop="rider.name" label="骑手" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="rider-name-nowrap">{{ scope.row.rider && scope.row.rider.name ? scope.row.rider.name : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rider.phone" label="电话" width="120" />
            <el-table-column
              prop="rider.status"
              label="状态"
              width="80"
            />
            <el-table-column
              label="手中订单数"
              width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.tasks ? scope.row.tasks.length : 0 }}
              </template>
            </el-table-column>
          </el-table>

          <div class="task-list" v-if="selectedRider">
            <h4>当前骑手订单</h4>
            <el-timeline>
              <el-timeline-item
                v-for="task in selectedRider.tasks"
                :key="task.id"
                color="#409EFF"
              >
                <p>订单号：{{ task.order_no || '-' }}</p>
                <p>{{ task.address }}</p>
                <p class="task-meta">
                  状态：{{ task.status }} ，收货人：{{ task.recipient_name }}（{{ task.recipient_phone }}）
                </p>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { getAdminAuthHeader } from '../utils/auth'
import { AMAP_WEB_KEY } from '@/config/mapConfig'

export default {
  name: 'RiderDispatch',
  data () {
    return {
      riderStatusList: [],
      selectedRider: null,
      map: null,
      markers: []
    }
  },
  mounted () {
    this.loadAmapScript().then(this.initMap)
    this.fetchRiderRealtimeStatus()
  },
  methods: {
    loadAmapScript () {
      return new Promise((resolve) => {
        if (window.AMap) {
          resolve()
          return
        }
        const existed = document.querySelector('script[data-amap]')
        if (existed) {
          existed.addEventListener('load', () => resolve())
          return
        }
        const script = document.createElement('script')
        script.setAttribute('data-amap', 'true')
        script.type = 'text/javascript'
        script.src = `https://webapi.amap.com/maps?v=2.0&key=${AMAP_WEB_KEY}`
        script.onload = () => resolve()
        document.body.appendChild(script)
      })
    },
    initMap () {
      const mapEl = document.getElementById('baidu-map')
      if (!mapEl) return

      // 已接入高德地图 JS API，使用真实地图
      if (window.AMap) {
        this.map = new window.AMap.Map('baidu-map', {
          zoom: 13,
          center: [120.15507, 30.27409] // 默认：杭州
        })
        return
      }

      // 否则渲染一个纯前端的「测试地图」占位，方便产品预览
      mapEl.classList.add('mock-map')
    },
    async fetchRiderRealtimeStatus () {
      try {
        const resp = await axios.get('/api/riders/realtime/status', {
          headers: getAdminAuthHeader()
        })
        if (resp.data && resp.data.code === 200) {
          this.riderStatusList = resp.data.data || []
          this.renderMarkers()
        }
      } catch (e) {
        console.error('获取骑手实时状态失败', e)
      }
    },
    renderMarkers () {
      if (!this.map || !window.AMap) return
      // 清除旧 marker
      this.markers.forEach(m => this.map.removeOverlay(m))
      this.markers = []

      this.riderStatusList.forEach(item => {
        if (!item.lastLocation) return
        const { lng, lat } = item.lastLocation
        const marker = new window.AMap.Marker({
          position: [Number(lng), Number(lat)]
        })
        marker.setMap(this.map)
        this.markers.push(marker)
      })
    },
    handleRiderClick (row) {
      this.selectedRider = row
      if (row.lastLocation && this.map && window.AMap) {
        this.map.setZoomAndCenter(15, [Number(row.lastLocation.lng), Number(row.lastLocation.lat)])
      }
    }
  }
}
</script>

<style scoped>
.dispatch-layout {
  height: calc(100vh - 120px);
}
.map-container {
  height: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}
.map-inner {
  width: 100%;
  height: 100%;
}

.mock-map {
  position: relative;
  background: radial-gradient(circle at top left, #e0f2fe, #eff6ff);
  border-radius: 12px;
  overflow: hidden;
}

.mock-map::before {
  content: '测试地图 · 请后续接入百度地图API';
  position: absolute;
  top: 14px;
  left: 16px;
  font-size: 12px;
  color: #64748b;
}

.mock-map::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: linear-gradient(#e5e7eb 1px, transparent 1px), linear-gradient(90deg, #e5e7eb 1px, transparent 1px);
  background-size: 32px 32px;
  opacity: 0.7;
}
.panel {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.task-list {
  margin-top: 12px;
  overflow: auto;
}
.task-meta {
  font-size: 12px;
  color: #666;
}

.rider-name-nowrap {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>

